<div
  class="fixed inset-0 z-40 flex items-end justify-center bg-black/50"
  (click)="handleClickOutside()"
>
  <!-- Modal container -->
  <div
    class="z-50 w-full max-w-md rounded-t-xl bg-white pb-2 shadow-lg"
    (click)="handleClickInside()"
  >
    <!-- Modal content -->
    <div class="modal-content rounded-lg p-6 shadow-lg">
      <h2 class="mb-4 text-xl font-bold">Abrir no aplicativo?</h2>

      <p class="mb-4">
        Você pode continuar no navegador ou abrir este conteúdo no
        aplicativo EsportesHub para uma melhor experiência.
      </p>

      <div class="flex flex-col gap-3">
        <button
          (click)="openApp()"
          class="w-full rounded-full bg-orange-500 px-4 py-4 font-medium text-white transition duration-200 hover:bg-orange-600"
        >
          Abrir no App
        </button>

        <button
          (click)="continueBrowser()"
          class="w-full rounded-full bg-gray-200 px-4 py-4 font-medium text-gray-800 transition duration-200 hover:bg-gray-300"
        >
          Continuar no navegador
        </button>

        <button
          (click)="openStore()"
          class="w-full py-4 text-sm font-medium text-orange-500 hover:text-orange-600"
        >
          Instalar o aplicativo
        </button>
      </div>

      <div class="mt-4 flex items-center">
        <input
          type="checkbox"
          id="dontShowAgain"
          [(ngModel)]="dontShowAgain"
          class="mr-2"
        />
        <label for="dontShowAgain" class="text-sm text-gray-600"
          >Não mostrar novamente</label
        >
      </div>
    </div>
  </div>
</div>
